export default __webpack_public_path__ + "static/media/Illustration2.e0f6cf8c.png";